// extracted by mini-css-extract-plugin
module.exports = {"pageSection":"_2o5SDDHB","btnImport":"_2QcgxV5M","loaderWrapper":"_2qo3NhwG","migrationSuccessContainer":"_1Cy7jWJr","importCustomerContainer":"_2u19Dv9i"};